// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../assets/css/Holiday.css";
// import { FaGlobeAsia, FaFlag, FaCalendarCheck, FaListUl } from "react-icons/fa";

// const Holiday = () => {
//   const [holidays, setHolidays] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const apiURL = "https://narrowitsolution.in/api/all-holiday?superAdminId=12";

//   useEffect(() => {
//     fetchHolidays();
//   }, []);

//   const fetchHolidays = async () => {
//     try {
//       const res = await axios.get(apiURL);
//       setHolidays(res.data.holidays || []);
//     } catch (err) {
//       console.error("Failed to load holidays", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateStr) => {
//     return new Date(dateStr).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   // 👉 Counting Summary
//   const totalHolidays = holidays.length;
//   const nationalCount = holidays.filter((h) => h.type === "National Holiday").length;
//   const regionalCount = holidays.filter((h) => h.type !== "National Holiday").length;
//   const upcomingCount = holidays.filter((h) => new Date(h.date) >= new Date()).length;

//   return (
//     <div className="holiday-list-container">

//       {/* 🌈 Gradient Banner */}
//       <div className="holiday-banner">
//         <h1>📅 Holiday Dashboard</h1>
//         <p>Your official list of holidays for the year</p>
//       </div>

//       {/* 📊 Summary Cards */}
//       <div className="holiday-summary">
//         <div className="summary-card">
//           <FaListUl className="summary-icon" />
//           <h3>{totalHolidays}</h3>
//           <p>Total Holidays</p>
//         </div>

//         <div className="summary-card">
//           <FaFlag className="summary-icon" />
//           <h3>{nationalCount}</h3>
//           <p>National Holidays</p>
//         </div>

//         <div className="summary-card">
//           <FaGlobeAsia className="summary-icon" />
//           <h3>{regionalCount}</h3>
//           <p>Regional Holidays</p>
//         </div>

//         <div className="summary-card">
//           <FaCalendarCheck className="summary-icon" />
//           <h3>{upcomingCount}</h3>
//           <p>Upcoming Holidays</p>
//         </div>
//       </div>

//       {/* 🔽 Holiday List */}
//       <h2 className="holiday-list-title">Holidays</h2>

//       {loading ? (
//         <p className="loading">Loading holidays...</p>
//       ) : holidays.length === 0 ? (
//         <p className="no-data">No holidays found</p>
//       ) : (
//         <div className="holiday-list-grid centered-grid">
//           {holidays.map((holiday) => (
//             <div key={holiday.id} className="holiday-card-ui">
//               <div className="holiday-card-header">
//                 <span className="holiday-name">{holiday.name}</span>
//                 <span className="holiday-type">{holiday.type}</span>
//               </div>

//               <p className="holiday-date">{formatDate(holiday.date)}</p>

//               <p className="holiday-region">
//                 <strong>Region:</strong> {holiday.region || "All"}
//               </p>

//               {holiday.description && (
//                 <p className="holiday-description">{holiday.description}</p>
//               )}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Holiday;

import React, { useEffect, useState } from "react";
import axios from "axios";
import "../assets/css/Holiday.css";
import { FaSearch, FaArrowLeft, FaArrowRight } from "react-icons/fa";

import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

import { useSelector, useDispatch } from "react-redux";

const Holiday = () => {

  const dispatch = useDispatch();
    const { profile } = useSelector((state) => state.userProfile);
  
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");

  const [totalPages, setTotalPages] = useState(1);
  const [superAdminId, setSuperAdminId] = useState(null);



  useEffect(() => {
      dispatch(fetchUserProfile());
    }, [dispatch]);

  useEffect(() => {
    // 👉 SuperAdminId from localStorage (or login token)
    const adminId = profile?.superAdminId || 12;
    setSuperAdminId(adminId);

    fetchHolidays(adminId);
  }, [page, search]);

  const fetchHolidays = async (adminId) => {
    try {
      setLoading(true);

      const apiURL = `https://narrowitsolution.in/api/all-holiday?superAdminId=${adminId}`;

      const res = await axios.get(apiURL);

      setHolidays(res.data.holidays || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.error("Failed to load holidays", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="holiday-container">

      {/* 🔍 Search Bar */}
      <div className="holiday-search-bar">
        <FaSearch className="holiday-search-icon" />
        <input
          type="text"
          placeholder="Search holidays..."
          value={search}
          onChange={(e) => {
            setPage(1);
            setSearch(e.target.value);
          }}
        />
      </div>

      <h2 className="table-title">Holiday List</h2>

      {/* 📋 Modern Table View */}
      <div className="holiday-table-wrapper">
        {loading ? (
          <p className="loading">Loading holidays...</p>
        ) : holidays.length === 0 ? (
          <p className="no-data">No holidays found</p>
        ) : (
          <table className="holiday-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Holiday Name</th>
                <th>Type</th>
                <th>Date</th>
                <th>Region</th>
                <th>Description</th>
              </tr>
            </thead>

            <tbody>
              {holidays.map((holiday, index) => (
                <tr key={holiday.id}>
                  <td>{(page - 1) * limit + index + 1}</td>
                  <td>{holiday.name}</td>
                  <td className="tag type-tag">{holiday.type}</td>
                  <td>{formatDate(holiday.date)}</td>
                  <td>{holiday.region || "All"}</td>
                  <td>{holiday.description || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* 📄 Pagination */}
      <div className="pagination">
        <button
          className="page-btn"
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          <FaArrowLeft /> Prev
        </button>

        <span className="page-number">
          Page {page} of {totalPages}
        </span>

        <button
          className="page-btn"
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

export default Holiday;
